<!-- Spinner.vue -->
<template>
  <div class="spinner">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
    >
      <rect
        opacity="0.7"
        x="23.728"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        fill="currentColor"
      />
      <rect
        opacity="0.4"
        y="26.2266"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(-90 0 26.2266)"
        fill="currentColor"
      />
      <rect
        opacity="0.2"
        x="13.4023"
        y="47.1719"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(-150 13.4023 47.1719)"
        fill="currentColor"
      />
      <rect
        opacity="0.05"
        x="38.4023"
        y="46.1309"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(150 38.4023 46.1309)"
        fill="currentColor"
      />
      <rect
        opacity="0.05"
        x="47.1719"
        y="36.5977"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(120 47.1719 36.5977)"
        fill="currentColor"
      />
      <rect
        opacity="0.9"
        x="46.1299"
        y="11.5977"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(60 46.1299 11.5977)"
        fill="currentColor"
      />
      <rect
        opacity="0.1"
        x="26.2256"
        y="49.9531"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(180 26.2256 49.9531)"
        fill="currentColor"
      />
      <rect
        x="49.9536"
        y="23.7285"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(90 49.9536 23.7285)"
        fill="currentColor"
      />
      <rect
        opacity="0.8"
        x="36.5977"
        y="2.82812"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(30 36.5977 2.82812)"
        fill="currentColor"
      />
      <rect
        opacity="0.6"
        x="11.5972"
        y="3.87109"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(-30 11.5972 3.87109)"
        fill="currentColor"
      />
      <rect
        opacity="0.5"
        x="2.82812"
        y="13.4023"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(-60 2.82812 13.4023)"
        fill="currentColor"
      />
      <rect
        opacity="0.3"
        x="3.87012"
        y="38.4023"
        width="3.7465"
        height="11.2395"
        rx="1.87325"
        transform="rotate(-120 3.87012 38.4023)"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<style scoped>
.spinner {
  display: inline-block;
  animation: spin 1.2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
